import { getJWTTokens } from '@shared/libs/local-storage';
import { buildPrivateApiPath } from '@shared/api/api-url';
import * as XLSX from 'xlsx';

export const downloadTemplate = async (source = 'structure'): Promise<void> => {
  const { accessToken } = getJWTTokens();

  const queryParam = source === 'guest' ? '?source=guest' : '?source=1cuu';
  const response = await fetch(buildPrivateApiPath(`/api/v1/xlsx/template${queryParam}`), {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    throw new Error('Ошибка при скачивании шаблона');
  }

  const data = await response.json();
  const headersString = data.template;

  const headersArray = headersString.split(';');
  const worksheetData = [headersArray];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Template');

  const filename = source === 'guest' ? 'шаблон внештатных участников.xlsx' : 'шаблон орг-структура.xlsx';
  XLSX.writeFile(workbook, filename);
};
